<template>
  <v-container id="usuarios" tag="section">
    <base-v-component heading="Partners del sistema " />
    <base-material-card
      color="indigo"
      icon="mdi-account-multiple"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click.stop="showDialog()">{{
          formTitle
        }}</v-btn>
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
        <!-- Dialog formulario-->
        <v-dialog v-model="dialog" max-width="700px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="nombre" label="nombre" />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    :items="negociosSelect"
                    v-model="negocios"
                    multiple
                    label="negocios"
                  />
                </v-col>
                <v-col cols="12" sm="8">
                  <v-list>
                    <v-list-item
                      v-for="c in negociosComisionesComputed"
                      :key="c.negocio"
                    >
                      <v-list-item-title>
                        {{ c.nombre }}
                      </v-list-item-title>
                      <v-list-item-action-text>
                        <v-text-field
                          v-model="c.comision"
                          label="comisión"
                          type="number"
                          step="0.05"
                        />
                      </v-list-item-action-text>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
                :loading="loadingForm"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <!--inicio tabla-->
      <v-data-table
        :headers="headers"
        :items="partners"
        :loading="loading"
        :search="search"
      >
        <!-- acciones -->
        <template v-slot:item.acciones="{ item }">
          <v-spacer></v-spacer>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="info"
                min-width="0"
                small
                v-on="on"
                @click="editar(item)"
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar partner usuario</span>
          </v-tooltip>
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="red"
                min-width="0"
                small
                v-on="on"
                :loading="loadingDelete"
                @click="deleteItem(item)"
              >
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Editar partner</span>
          </v-tooltip> -->
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      id: null,
      nombre: "",
      negocios: [],
      loading: false,
      loadingForm: false,
      loadingDelete: false,
      dialog: false,
      search: "",
      headers: [
        {
          sortable: false,
          text: "Nombre",
          value: "nombre",
        },
        {
          sortable: false,
          text: "Negocios",
          value: "negociosMostrar",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
    };
  },
  watch: {
    dialog(v) {
      if (!v) this.close();
    },
  },
  computed: {
    ...mapState({
      partnersBruto: (state) => state.partners.partners,
      negociosSelect: (state) => state.app.negociosGestArray,
    }),
    negociosComisionesComputed() {
      console.log(
        this.negociosSelect.filter((n) => this.negocios.includes(n.value))
      );
      return this.negociosSelect
        .filter((n) => this.negocios.includes(n.value))
        .map((n) => {
          var foundComision = this.negociosComisiones
            ? this.negociosComisiones.find((nC) => nC.negocio == n.value)
            : false;
          return {
            id: n.value,
            nombre: n.text,
            comision: foundComision ? foundComision.comision : 0.0,
          };
        });
    },
    partners() {
      return this.partnersBruto.map((p) => {
        return {
          ...p,
          negociosMostrar: p.negocios.join(", "),
        };
      });
    },
    formTitle() {
      return !this.id ? "Nuevo Partner" : "Editar partner " + this.nombre;
    },
  },
  methods: {
    showDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.nombre = "";
      this.negocios = [];
    },
    reload() {
      this.loading = true;
      this.$store.dispatch("partners/getPartners").finally(() => {
        this.loading = false;
      });
    },
    save() {
      const _vm = this;
      this.loadingForm = true;
      this.negociosComisiones = this.negociosComisionesComputed.map((nC) => {
        return {
          negocio: nC.id,
          comision: parseFloat(nC.comision),
        };
      });
      console.log(this.negociosComisiones);
      this.$store
        .dispatch("partners/savePartner", {
          id: this.id,
          nombre: this.nombre,
          negocios: this.negocios,
          negociosComisiones: this.negociosComisiones,
        })
        .then((res) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Partner grabado con éxito",
          });
          _vm.reload();
          _vm.dialog = false;
        })
        .catch((error) => {
          console.log(error);
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar el partner: " + error.data,
          });
        })
        .finally(() => {
          _vm.loadingForm = false;
        });
    },
    editar(item) {
      console.log(item.negociosComisiones);
      this.dialog = true;
      this.nombre = item.nombre;
      this.id = item.id;
      this.negocios = item.negocios;
      this.negociosComisiones = item.negociosComisiones;
    },
    deleteItem(item) {},
  },
};
</script>

<style>
</style>